import availableJobCategories from '@/helpers/availableJobCategoriesHelper'
import availableEthnicities from '@/helpers/ethnicityHelper'
import availableHairColors from '@/helpers/hairColorHelper'
import availableSocialNetworks from '@/helpers/socialNetworkHelper'

export default function () {
  return {
    user: null,
    availableJobCategories,
    availableEthnicities,
    availableHairColors,
    availableSocialNetworks,
    symplaParticipationColumns: [
      {
        key: 'event',
        label: 'Evento'
      },
      {
        key: 'percentCompleted',
        label: 'Progresso (%)'
      },
      {
        key: 'actions',
        label: ''
      }
    ]
  }
}
